<template>
  <div>
    <GlobalHeader />

    <!-- SPメニューグローバル -->
    <div class="spMenuHeader sp">
      <ul>
        <li><router-link to="/about" :class="{ location: isSelected('/about') }">開催概要</router-link></li>
        <li><div @click="clickSpMenu('/t10s')" :class="{ location: isSelected('/t10s') }"><span class="t10s01">東京カメラ部<br></span><span class="t10s02">10選</span></div></li>
        <li><div @click="clickSpMenu('/j100v')" :class="{ location: isSelected('/j100v') }">日本写真<br>100景</div></li>
        <li><div @click="clickSpMenu('/sponsors')" :class="{ location: isSelected('/sponsors') }">協賛団体<br>展示</div></li>
        <li><div @click="clickSpMenu('/organizer')" :class="{ location: isSelected('/organizer') }">主催者<br>企画</div></li>
      </ul>
    </div>

    <div v-if="!isSelected('/sponsors') || !isDemo()" class="pc">

      <!-- PCメニュー1階層目 -->
      <div class="categoryHead01" :class="{ categoryHeadBottomNon: !this.isWinnerList() }"><!-- categoryHeadBottomNonはサブメニューがない時に適用するクラス -->
        <div class="inner">
          <nav class="categoryHeadArea">
            <ul class="specials">
              <li v-for="data in createHeaderList()" :key="data.key">
                <router-link :to="data.to" :class="{ location: data.isSelected }">{{ data.label }}</router-link>
              </li>
            </ul>
          </nav>
        </div><!-- /inner-->
      </div><!-- /categoryHead-->

      <!-- PCメニュー2階層目 -->
      <transition name="header1" @before-enter="beforeEnterHeader" @enter="enterHeader" @before-leave="beforeLeaveHeader" @leave="leaveHeader">
        <div v-if="isOpenHeader1" class="categoryHead02">
          <div class="inner">
            <nav class="categoryHeadArea">
              <ul class="specials">
                <li v-for="data in createHeader1List()" :key="data.key">
                  <router-link :to="data.to" :class="{ location: data.isSelected }">{{ data.label }}</router-link>
                </li>
              </ul>
            </nav>
          </div><!-- /inner-->
        </div><!-- /categoryHead-->
      </transition>


      <!-- PCメニュー3階層目 -->
      <transition name="header2" @before-enter="beforeEnterHeader" @enter="enterHeader" @before-leave="beforeLeaveHeader" @leave="leaveHeader">
        <div v-if="isOpenHeader2" class="categoryHead03">
          <div class="inner">
            <nav class="categoryHeadArea">
              <ul class="specials">
                <li v-for="data in createHeader2List()" :key="data.key">
                  <router-link :to="data.to" :class="{ location: data.isSelected }">{{ data.label }}</router-link>
                </li>
              </ul>
            </nav>
          </div><!-- /inner-->
        </div><!-- /categoryHead-->
      </transition>

    </div>

    <div v-if="!isSelected('/sponsors') || !isDemo()" class="spHeader sp">
      <!-- SPメニュー1階層目 -->
      <transition name="headerMain" @before-enter="beforeEnterHeader" @enter="enterHeader" @before-leave="beforeLeaveHeader" @leave="leaveHeader">
        <div v-if="isOpenHeaderMain" class="headerMain">
          <ul>
            <li v-for="data in createHeaderList()" :key="data.key" :class="{ location: data.isSelected, twoPans: data.isTwoPanes }">
              <router-link :to="data.to">{{ data.label }}</router-link>
            </li>
          </ul>
        </div>
      </transition>

      <!-- SPメニュー2階層目 -->
      <transition name="header1" @before-enter="beforeEnterHeader" @enter="enterHeader" @before-leave="beforeLeaveHeader" @leave="leaveHeader">
        <div v-if="isOpenHeader1" class="header1">
          <ul>
            <li v-for="data in createHeader1List()" :key="data.key" :class="{ location: data.isSelected }">
              <router-link :to="data.to">{{ data.label }}</router-link>
            </li>
          </ul>
        </div>
      </transition>

      <!-- SPメニュー3階層目 -->
      <transition name="header2" @before-enter="beforeEnterHeader" @enter="enterHeader" @before-leave="beforeLeaveHeader" @leave="leaveHeader">
        <div v-if="isOpenHeader2" class="header2">
          <ul :class="{ evenList: isEvenHeader2ListSp }">
            <li v-for="data in createHeader2List()" :key="data.key" :class="{ location: data.isSelected, onePans: data.isOnePans }">
              <router-link :to="data.to">{{ data.label }}</router-link>
            </li>
          </ul>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalHeader from './GlobalHeader'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    GlobalHeader
  },
  data () {
    return {
      isOpenHeaderMain: true,
      isOpenHeader1: false,
      isOpenHeader2: false,

      keepHeader1ChangeCondition: null,
      keepHeader2ChangeCondition: null,

      // 偶数フラグ
      isEvenHeader2ListSp: false,
      // window幅保持変数
      keepWindowInnerWidth: null
    }
  },
  mounted () {
    this.changePath()
    // winnersのvuexへの読み込み状態を監視し、読み込まれたら表示を更新する
    if (!this.winnes) {
      this.unsubscribe = this.$store.subscribe(async (mutation, state) => {
        if (mutation.type === 'setWinners') {
          // 一度だけ実行できればいい処理なので、最初で購読解除をする
          this.unsubscribe()

          // winnersが設定された段階で、メニューの表示を描画する
          setTimeout(() => {
            this.changePath(true) // 念の為遅延実行
            this.keepWindowInnerWidth = window.innerWidth // 現在の幅を取得しておく
          }, 500)
        }
      })
    }

    // ウインドウ幅変更イベントリスナー登録
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy: function () {
    // ウインドウ幅変更イベントリスナー解除
    window.removeEventListener('resize', this.handleResize)
  },
  computed: {
    ...mapGetters(['winners', 'areas'])
  },
  watch: {
    '$route.path': function () {
      this.changePath()
    }
  },
  methods: {
    createHeaderList () {
      const list = []
      if (this.isSelected('/t10s')) { // 10選の場合の出力内容設定
        for (const key in this.awardYears) {
          const year = this.awardYears[key]
          list.push({
            to: `/t10s/${year}`,
            isSelected: this.isSelected(`/t10s/${year}`),
            label: year,
            key: year
          })
        }
      } else if (this.isSelected('/j100v')) { // 100景の場合の出力内容設定
        if (!this.areas || !this.areas.length) return
        for (const area of this.areas) {
          list.push({
            to: `/j100v/${this.areaAlphabetMap[area.name]}`,
            isSelected: this.isSelected(`/j100v/${this.areaAlphabetMap[area.name]}`),
            label: area.name,
            key: area.id
          })
        }
      } else if (this.isSelected('/organizer')) { // 主催者企画の場合の出力内容設定
        list.push({ to: `/organizer/twitter`, isSelected: this.isSelected(`/organizer/twitter`), label: 'Twitterフォトコンテスト', key: 'twitter', isTwoPanes: true })
        list.push({ to: `/organizer/jtg`, isSelected: this.isSelected(`/organizer/jtg`), label: 'Japan Travel Gallery Photo Contest 2021', key: 'jtg', isTwoPanes: true })
        list.push({ to: `/organizer/weibo`, isSelected: this.isSelected(`/organizer/weibo`), label: 'Weibo', key: 'weibo', isTwoPanes: true })
      } else if (this.isSelected('/events')) { // イベントカレンダーの場合の出力内容設定
        /*
        list.push({ to: `/events`, isSelected: (this.$route.path == '/events'), label: '主催者公式イベント', key: 'events', isTwoPanes: true })
        list.push({ to: `/events/exhibitors`, isSelected: this.isSelected(`/events/exhibitors`), label: '出展者自主企画イベント', key: 'exhibitors', isTwoPanes: true })
        */
        list.push({ to: `/events/archives`, isSelected: this.isSelected(`/events/archives`), label: '主催者公式イベントアーカイブ', key: 'archives', isTwoPanes: true })
        /*
        list.push({ to: `/events/report_canon`, isSelected: this.isSelected(`/events/report_canon`), label: 'レポート：キヤノン', key: 'report_canon', isTwoPanes: true })
        list.push({ to: `/events/report_raytrek`, isSelected: this.isSelected(`/events/report_raytrek`), label: 'レポート：サードウェーブ', key: 'report_raytrek', isTwoPanes: true })
        list.push({ to: `/events/report_biei`, isSelected: this.isSelected(`/events/report_biei`), label: 'レポート：美瑛町', key: 'report_biei', isTwoPanes: true })
        */
      }
      return list
    },
    createHeader1List () {
      const list = []
      if (this.isSelected('/j100v/') && this.$route.params.area) { // 100景の場合の出力内容設定
        for (const prefName in this.prefecturesMap) {
          const areaName = this.prefecturesMap[prefName]
          const alphabetAreaName = this.areaAlphabetMap[areaName]
          if (alphabetAreaName !== this.$route.params.area) continue
          const alphabetPrefName = this.prefecturesAlphabetMap[prefName]
          list.push({
            to: `/j100v/${alphabetAreaName}/${alphabetPrefName}`,
            isSelected: this.isSelected(`/j100v/${alphabetAreaName}/${alphabetPrefName}`),
            label: prefName,
            key: alphabetPrefName
          })
        }
      } else if (this.isSelected('/organizer/twitter')) { // twitterの場合の出力内容設定
        list.push({ to: `/organizer/twitter/snap`, isSelected: this.isSelected(`/organizer/twitter/snap`), label: 'スナップ部門', key: 'snap' })
        list.push({ to: `/organizer/twitter/poster`, isSelected: this.isSelected(`/organizer/twitter/poster`), label: 'ポスター部門', key: 'jtg' })
        list.push({ to: `/organizer/twitter/portrait`, isSelected: this.isSelected(`/organizer/twitter/portrait`), label: 'ポートレート部門', key: 'portrait' })
      }
      return list
    },
    createHeader2List () {
      const list = []
      if (this.isSelected('/t10s') && this.$route.params.year) { // 10選の場合の出力内容設定
        for (const winner of this.winners) {
          if (winner.awardType >= this.EnumAwardTypeTcc10Sen2020 && winner.awardType <= this.EnumAwardTypeTcc10Sen2012 && this.awardYears[winner.awardType] == this.$route.params.year) {
            list.push({
              to: `/t10s/${this.$route.params.year}/${winner.id}`,
              isSelected: this.isSelected(`/t10s/${this.$route.params.year}/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/j100v/') && this.$route.params.pref) { // 100景の場合の出力内容設定
        for (const winner of this.winners) {
          if (winner.awardType == this.EnumAwardTypeJapan100Views && this.prefecturesAlphabetMap[winner.mainImageTitle] == this.$route.params.pref) {
            list.push({
              to: `/j100v/${this.$route.params.area}/${this.$route.params.pref}/${winner.id}`,
              isSelected: this.isSelected(`/j100v/${this.$route.params.area}/${this.$route.params.pref}/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/organizer/twitter/') && this.$route.params.category == 'snap') { // twitter snapの場合の出力内容設定
        for (const winner of this.winners) {
          if (this.$route.params.category == 'snap' && winner.awardType == this.EnumAwardTypeTwitterSnap) {
            list.push({
              to: `/organizer/twitter/snap/${winner.id}`,
              isSelected: this.isSelected(`/organizer/twitter/snap/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/organizer/twitter/') && this.$route.params.category == 'poster') { // twitter posterの場合の出力内容設定
        for (const winner of this.winners) {
          if (this.$route.params.category == 'poster' && winner.awardType == this.EnumAwardTypeTwitterPoster) {
            list.push({
              to: `/organizer/twitter/poster/${winner.id}`,
              isSelected: this.isSelected(`/organizer/twitter/poster/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/organizer/twitter/') && this.$route.params.category == 'portrait') { // twitter portraitの場合の出力内容設定
        for (const winner of this.winners) {
          if (this.$route.params.category == 'portrait' && winner.awardType == this.EnumAwardTypeTwitterPortrait) {
            list.push({
              to: `/organizer/twitter/portrait/${winner.id}`,
              isSelected: this.isSelected(`/organizer/twitter/portrait/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/organizer/jtg')) { // jtgの場合の出力内容設定
        for (const winner of this.winners) {
          if (winner.awardType == this.EnumAwardTypeJtg) {
            list.push({
              to: `/organizer/jtg/${winner.id}`,
              isSelected: this.isSelected(`/organizer/jtg/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/organizer/weibo')) { // weiboの場合の出力内容設定
        for (const winner of this.winners) {
          if (winner.awardType == this.EnumAwardTypeWeibo) {
            list.push({
              to: `/organizer/weibo/${winner.id}`,
              isSelected: this.isSelected(`/organizer/weibo/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/sponsors')) { // 協賛団体展示
        for (const winner of this.winners) {
          if (winner.awardType === this.EnumAwardTypeSpecialExhibitons) {
            list.push({
              to: `/sponsors/${winner.id}`,
              isSelected: this.isSelected(`/sponsors/${winner.id}`),
              label: winner.name,
              key: winner.id
            })
          }
        }
      } else if (this.isSelected('/events')) { // イベントカレンダーの場合の出力内容設定
        list.push({ to: `/events/report_canon`, isSelected: this.isSelected(`/events/report_canon`), label: 'キヤノンマーケティングジャパン株式会社', key: 'report_canon', isOnePans: true })
        list.push({ to: `/events/report_biei`, isSelected: this.isSelected(`/events/report_biei`), label: '美瑛町（ＮＰＯ法人　美瑛町写真映像協会）', key: 'report_biei', isOnePans: true })
        list.push({ to: `/events/report_raytrek`, isSelected: this.isSelected(`/events/report_raytrek`), label: '株式会社サードウェーブ', key: 'report_raytrek', isOnePans: true })
      }
      this.isEvenHeader2ListSp = (list && list.length && list.length % 2 === 0)
      return list
    },
    handleResize () {
      // 横幅がリサイズされた場合のみメニューを再表示
      if (this.keepWindowInnerWidth != window.innerWidth) {
        this.keepWindowInnerWidth = window.innerWidth
        this.changePath(true)
      }
    },
    changePath (forceReopen = false) {
      const mediaQuery = window.matchMedia('(max-width: 640px)')
      if (this.$route.path.match(/^\/t10s\/\d{4}\/\d+/)) {                     // 10選年受賞者指定
        const isReOpen = (this.keepHeader2ChangeCondition != this.$route.params.year) // 年が前回と違ってたら、ヘッダー2は閉じてから開く
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.closeHeader1()
          this.openHeader2(isReOpen || forceReopen)
        }
        this.keepHeader2ChangeCondition = this.$route.params.year
      } else if (this.$route.path.match(/^\/t10s\/\d{4}$/)) {                  // 10選年
        this.closeHeader1()
        this.openHeader2(true)
      } else if (this.$route.path.match(/^\/t10s$/)) {                         // 10選
        this.closeHeader1()
        this.closeHeader2()
      } else if (this.$route.path.match(/^\/j100v\/[a-z]+\/[a-z]+\/\d+$/)) {   // 100景エリア都道府県指定受賞者指定
        const isReOpen = (this.keepHeader2ChangeCondition != this.$route.params.pref) // 都道府県が前回と違ってたら、ヘッダー2は閉じてから開く
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.openHeader1(forceReopen)
          this.openHeader2(isReOpen || forceReopen)
        }
        this.keepHeader2ChangeCondition = this.$route.params.pref
      } else if (this.$route.path.match(/^\/j100v\/[a-z]+\/[a-z]+$/)) {        // 100景エリア都道府県指定
        const isReOpen = (this.keepHeader1ChangeCondition != this.$route.params.area) // 都道府県が前回と違ってたら、ヘッダー2は閉じてから開く
        this.openHeader1(forceReopen)
        this.openHeader2(isReOpen || forceReopen)
        this.keepHeader1ChangeCondition = this.$route.params.pref
      } else if (this.$route.path.match(/^\/j100v\/[a-z]+$/)) {                // 100景エリア指定
        const isReOpen = (this.keepHeader1ChangeCondition != this.$route.params.area) // 都道府県が前回と違ってたら、ヘッダー2は閉じてから開く
        this.openHeader1(isReOpen || forceReopen)
        this.closeHeader2()
        this.keepHeader1ChangeCondition = this.$route.params.pref
      } else if (this.$route.path.match(/^\/j100v$/)) {                        // 100景
        this.closeHeader1()
        this.closeHeader2()
      } else if (this.$route.path.match(/^\/organizer\/twitter\/[a-z]+\/\d+$/)) {   // twitter受賞者指定
        const isReOpen = (this.keepHeader2ChangeCondition != this.$route.params.category) // 部門が前回と違ってたら、ヘッダー2は閉じてから開く
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.openHeader1(forceReopen)
          this.openHeader2(isReOpen || forceReopen)
        }
        this.keepHeader2ChangeCondition = this.$route.params.category
      } else if (this.$route.path.match(/^\/organizer\/twitter\/[a-z]+$/)) {   // twitter部門
        this.openHeader1(forceReopen)
        this.openHeader2(true)
      } else if (this.$route.path.match(/^\/organizer\/twitter$/)) {           // twitter
        this.openHeader1(true)
        this.closeHeader2()
      } else if (this.$route.path.match(/^\/organizer\/jtg\/\d+$/)) {          // jtg受賞者
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.closeHeader1()
          this.openHeader2(forceReopen)
        }
      } else if (this.$route.path.match(/^\/organizer\/jtg$/)) {               // jtg
        this.closeHeader1()
        this.openHeader2(true)
      } else if (this.$route.path.match(/^\/organizer\/weibo\/\d+$/)) {          // weibo受賞者
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.closeHeader1()
          this.openHeader2(forceReopen)
        }
      } else if (this.$route.path.match(/^\/organizer\/weibo$/)) {               // weibo
        this.closeHeader1()
        this.openHeader2(true)
      } else if (this.$route.path.match(/^\/organizer$/)) {                      // 主催者企画
        this.openHeaderMain()
        this.closeHeader1()
        this.closeHeader2()
      } else if (this.$route.path.match(/^\/sponsors\/\d+$/)) {                      // 協賛団体展示個別ページ
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        } else {
          this.closeHeaderMain()
          this.closeHeader1()
          this.openHeader2(forceReopen)
        }
      } else if (this.$route.path.match(/^\/sponsors$/)) {                      // 協賛団体展示
        this.closeHeaderMain()
        this.closeHeader1()
        this.openHeader2(forceReopen)
      } else if (this.$route.path.match(/^\/events/)) {                      // イベントカレンダー
        this.openHeaderMain()
        this.closeHeader1()
        // this.closeHeader2()
        this.openHeader2()
      } else {
        if (mediaQuery.matches) {
          this.closeHeaderMain()
          this.closeHeader1()
          this.closeHeader2()
        }
      }
    },
    isSelected (str) {
      return this.$route.path.indexOf(str) >= 0
    },
    isWinnerList () {
      return (this.$route.path === '/exhibitors')
    },
    clickSpMenu (route) {
      // 現在のパスがwinner表示だった場合、画面を遷移せずに、メニューのみを表示する
      // 押されたメニューを確認
      if (route === '/t10s' && this.$route.path.match(/^\/t10s\/\d{4}\/\d+$/)) { // 10選メニュー
        this.openHeaderMain()
        this.openHeader2()
      } else if (route === '/j100v' && this.$route.path.match(/^\/j100v\/[a-z]+\/[a-z]+\/\d+$/)) { // 100景メニュー
        this.openHeaderMain()
        this.openHeader1()
        this.openHeader2()
      } else if (route === '/sponsors' && this.$route.path.match(/^\/sponsors\/\d+$/)) { // 協賛団体展示メニュー
        this.closeHeaderMain()
        this.closeHeader1()
        this.openHeader2()
      } else if (route === '/organizer' &&
        (this.$route.path.match(/^\/organizer\/twitter\/(snap|poster|portrait)\/\d+$/) ||
        this.$route.path.match(/^\/organizer\/jtg\/\d+$/) ||
        this.$route.path.match(/^\/organizer\/weibo\/\d+$/))) { // 主催者企画メニュー
        this.openHeaderMain()
        this.openHeader1()
        this.openHeader2()
      } else if (route != this.$route.path) {
        this.$router.push(route)
      }
    },
    isDemo () {
      return process.env.VUE_APP_DEMO_HOST ? (location.host.indexOf(process.env.VUE_APP_DEMO_HOST) >= 0) : false
    },
    openHeaderMain () {
      setTimeout(() => { this.isOpenHeaderMain = true }, 200)
      // setTimeout(() => {
      //   this.isOpenHeaderMain = false
      //   setTimeout(() => {
      //     this.isOpenHeaderMain = true
      //   }, 100)
      // }, 100)
    },
    closeHeaderMain () {
      setTimeout(() => { this.isOpenHeaderMain = false }, 200)
    },
    openHeader1 (isReOpen) {
      if (isReOpen) this.isOpenHeader1 = false
      setTimeout(() => { this.isOpenHeader1 = true }, 200)
      // setTimeout(() => {
      //   this.isOpenHeader1 = false
      //   setTimeout(() => {
      //     this.isOpenHeader1 = true
      //   }, 100)
      // }, 100)
    },
    closeHeader1 () {
      setTimeout(() => { this.isOpenHeader1 = false }, 200)
    },
    openHeader2 (isReOpen) {
      if (isReOpen) this.isOpenHeader2 = false
      setTimeout(() => { this.isOpenHeader2 = true }, 200)
      // setTimeout(() => {
      //   this.isOpenHeader2 = false
      //   setTimeout(() => {
      //     this.isOpenHeader2 = true
      //   }, 100)
      // }, 100)
    },
    closeHeader2 () {
      setTimeout(() => { this.isOpenHeader2 = false }, 200)
    },
    beforeEnterHeader (el) {
      el.style.height = '0'
    },
    enterHeader (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    beforeLeaveHeader (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    leaveHeader (el) {
      el.style.height = '0'
    }
  }
}
</script>

<style scoped>
/* アニメーション中のスタイル */
.headerMain-leave-active,
.header1-leave-active,
.header1-enter-active {
  transition: height 0.2s, opacity 0.2s;
}

.headerMain-leave-active,
.header2-leave-active,
.header2-enter-active {
  transition: height 0.2s, opacity 0.2s;
}

.categoryHeadSub {
  overflow: hidden;
}

.headerMain-enter {
  opacity: 0;
}
.headerMain-enter-to {
  opacity: 1;
}
.headerMain-leave {
  opacity: 1;
}
.headerMain-leave-to {
  opacity: 0;
}

.header1-enter {
  opacity: 0;
}
.header1-enter-to {
  opacity: 1;
}
.header1-leave {
  opacity: 1;
}
.header1-leave-to {
  opacity: 0;
}

.header2-enter {
  opacity: 0;
}
.header2-enter-to {
  opacity: 1;
}
.header2-leave {
  opacity: 1;
}
.header2-leave-to {
  opacity: 0;
}
</style>
